<nav
  class="bg-black text-white"
  *ngIf="!!store.user()"
  mat-tab-nav-bar
  color="accent"
  backgroundColor="primary"
  [tabPanel]="tabPanel"
>
  <h1 style="min-width: 223px" class="p-4 pt-2 pb-0 text-xl font-bold">
    <a [routerLink]="['/', 'dashboard']">Pixel Tracking Admin</a>
  </h1>
  @for (navLink of navLinks; track navLink.title) {
  <a
    mat-tab-link
    [routerLink]="navLink.link"
    routerLinkActive
    #rla="routerLinkActive"
    [active]="rla.isActive"
  >
    {{ navLink.title }}
  </a>
  }
  <div style="width: 100%"></div>
  <pxl-user-menu></pxl-user-menu>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
